import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const getShippingCost = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/shipping/cost'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const shippingApi = {
	getShippingCost,
}

export default shippingApi
